/* eslint-disable */

export const enum PartnerAccessChangeAccessLevel {
  mandant = 1,
  customerAndMandant = 2,
}
